<template>
	<div class="banner">
		<div class="path" @click="goHome">
			首页 > <span>详情介绍</span>
		</div>
		<div class="center">
			<div class="title">
				{{list.title}}
			</div>
			<div class="text">
				<div class="name">
					<!-- <div>发布人:<span>王世杰</span></div> -->
				</div>
				<div class="time">
					发布时间:<span>{{utils.getNowTime(list.createTime)}}</span>
				</div>
			</div>
			<div class="ql-editor">
				<div class="content" v-html="list.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getBanner
	} from '@/api/api.js'
	export default {
		data() {
			return {
				id: '',
				list: {},
			}
		},
		mounted() {
			this.id = this.$route.params.id;
			this.getData();
		},
		methods: {
			goHome(){
				this.$router.push('/allcontent')
			},
			getData() {
				getBanner({
					id: this.id
				}).then(res => {
					if (res.code == 0) {
						this.list = res.data;
						this.list.content = this.list.content.replace(/<img/g,
							'<img mode="widthFix" style="width: 98%"');
					}
				})
			}
		}
	}
</script>

<style scoped>
	.banner {
		width: 1200px;
		margin: auto;
	}

	.path {
		height: 54px;
		line-height: 54px;
		font-size: 14px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #999999;
	}

	.path span {
		font-size: 14px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #2D2D2E;
	}

	.center {
		width: 1200px;
		border-radius: 8px;

	}

	.center .title {
		font-size: 30px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #000000;
		padding-top: 32px;
		text-align: center;
	}

	.center .text {
		width: 1168px;
		border-bottom: 1px solid #EFEFEF;
		padding: 24px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: auto;
	}

	.center .name {
		font-size: 14px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #999999;

		span {
			color: #222222;
		}
	}

	.center .time {
		font-size: 14px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #999999;

		span {
			color: #222222;
		}
	}
</style>